import { apiClient } from './apiClient';
import { User, SurveyorProfile, PaginatedResponse } from '../types';

export const userService = {
  async getProfile(): Promise<User> {
    const { data } = await apiClient.get<User>('/users/me/');
    return data;
  },

  async updateProfile(payload: Partial<User>): Promise<User> {
    const { data } = await apiClient.patch<User>('/users/me/', payload);
    return data;
  },

  async getSurveyorProfile(id: string): Promise<SurveyorProfile> {
    const { data } = await apiClient.get<SurveyorProfile>(`/surveyors/${id}/`);
    return data;
  },

  async listSurveyors(params?: {
    service_type?: string;
    city?: string;
    is_available?: boolean;
    search?: string;
    page?: number;
  }): Promise<PaginatedResponse<SurveyorProfile>> {
    const { data } = await apiClient.get<PaginatedResponse<SurveyorProfile>>(
      '/surveyors/',
      { params },
    );
    return data;
  },

  async updateSurveyorProfile(payload: Partial<SurveyorProfile>): Promise<SurveyorProfile> {
    const { data } = await apiClient.patch<SurveyorProfile>('/surveyors/profile/', payload);
    return data;
  },

  async uploadVerificationDoc(file: {
    uri: string;
    name: string;
    type: string;
  }): Promise<{ id: string; file_url: string }> {
    const formData = new FormData();
    formData.append('file', {
      uri: file.uri,
      name: file.name,
      type: file.type,
    } as any);

    const { data } = await apiClient.post(
      '/surveyors/profile/verification-docs/',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },

  /** Web-compatible file upload using browser FormData directly */
  async uploadVerificationDocWeb(formData: FormData): Promise<{ id: string; file_url: string }> {
    const { data } = await apiClient.post(
      '/surveyors/profile/verification-docs/',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },
};
